import { useEffect, useState } from "react";
import Cookies from 'js-cookie';
import { useNavigate } from "react-router-dom";
import socket from 'socket.io-client';
import { jwtDecode } from 'jwt-decode';
import UpdateSurveyorProfile from '../Landing/UpdateSurveyorProfile';
import { GetSurveyors } from "./GetSurveyors";
import axios from "axios";
const io = socket.connect('https://land-survey-main-server.onrender.com');

export default function SurveyorDashboard() {
const [activeTab, setActiveTab] = useState("messages");
// --- New Chat Selection State ---
const [selectedSurveyor, setSelectedSurveyor] = useState(null);
const [surveyorsList, setsurveyorsList] = useState([]);

const [chat, setChat] = useState([]);
const [input, setInput] = useState("");
const [report, setReport] = useState("");
const [messages, setMessages] = useState([]);

// --- Responsive Sidebar Toggle State ---
const [isSidebarOpen, setIsSidebarOpen] = useState(false);

// --- Profile State ---
const [profileData, setProfileData] = useState({
name: '',
email: '',
phoneNumber: '',
password: '',
imagePreview: '',
tempDisp: null 
});

// --- Dynamic Assigned Projects State ---
const [assignedProjects, setAssignedProjects] = useState([]);

const [range,setRange] = useState(null);
const [title,setTitle] = useState(null);
const [textArea,setTextArea] = useState(null);

// Input state for constructing a fresh manual tracking item 
const [newProjectName, setNewProjectName] = useState("");

const [myid, setmyid] = useState(null);
const [myName, setmyName] = useState(null);
const Navigete = useNavigate();

const submitReport = () => {
io.emit('messageToAdmin', { report, senderId: myid });
alert("Report submitted: " + report);
setReport("");
};

// --- Create New Project Tracker Handler ---
const handleCreateProject = async(e) => {
  e.preventDefault();
  if (!newProjectName.trim()) {
    alert("Please enter a valid project name.");
    return;
  }
  
  
  try {
    const result = await axios.post('https://land-survey-main-server.onrender.com/CreateNewProject',{
      projectName: newProjectName,
      Requestprogress: 0,
      progressTitle: null,
      progressSummary: null
    });

    if(result?.data?.project){
    setAssignedProjects(prev => [...prev,result.data.project]);
    }
    
  } catch (err) {
    console.error('Something went wrong during creating new project:',err);
  }
  
  setNewProjectName("");
  alert(`Project tracking created for "${newProjectName}"!`);
};

// --- Delete Project Tracker Handler ---
const handleDeleteProject = (projectId, projectName) => {
  if (window.confirm(`Are you sure you want to delete the progress tracking for "${projectName}"?`)) {
    setAssignedProjects(prev => prev.filter(p => p.id !== projectId));
  }
};


const handleUpdateProgress = async (id, currentProgress) => {
  const targetProject = assignedProjects.find(p => p.id === id);
  if (!targetProject) return;

  // Validation: Check that fields aren't completely blank
  if (!targetProject.progressTitle?.trim() || !targetProject.progressSummary?.trim()) {
    alert("Please provide both an Activity Title and Summary before saving.");
    return;
  }

  try {
    const result = await axios.post('https://land-survey-main-server.onrender.com/UpdateProjectProgress', {
      id: id,
      surveyorId: myid, // Logs exactly which worker is sending this entry
      Requestprogress: currentProgress,
      progressTitle: targetProject.progressTitle,
      progressSummary: targetProject.progressSummary
    });

    if (result?.data?.status) {
      alert("Activity snapshot permanently recorded for Admin & Client review!");
      
      // Clear out entry textareas locally so surveyor is ready for their next separate entry
      setAssignedProjects(prev => 
        prev.map(item => item.id === id ? { ...item, progressTitle: "", progressSummary: "" } : item)
      );
    }
  } catch (err) {
    console.error('Error logging unique progress snapshot:', err);
    alert("Failed to submit unique activity entry.");
  }
};

const handleUpdateProfile = async(e) => {
e.preventDefault();
const surveyor_token = Cookies.get('Surveyor_token');
const formData = new FormData();
formData.append('surveyor_name', profileData.name);
formData.append('surveyor_email', profileData.email);
formData.append('surveyor_password', profileData.password);
formData.append('surveyor_phone', profileData.phoneNumber);
formData.append('surveyor_image', profileData.imagePreview);
formData.append('surveyor_token', surveyor_token);

const UpdatedProfile = await UpdateSurveyorProfile(formData);
if(UpdatedProfile.error === true){
alert(UpdatedProfile.message);
} else {
const newToken = UpdatedProfile.newToken;
Cookies.set('Surveyor_token', newToken, { path: '/' });
setmyid(UpdatedProfile.data.member_id);
setProfileData({
name: UpdatedProfile.data.member_name,
email: UpdatedProfile.data.member_email,
tempDisp: null,
imagePreview: UpdatedProfile.data.member_image,
phoneNumber: UpdatedProfile.data.member_phonenumber
});
alert('you have updated your profile successfully!');
}
};

const getProjects = async() => {
  try {
  const result = await axios.get('https://land-survey-main-server.onrender.com/getProjects');
  if(!result?.data && !result.data.status){
  return  console.log(result.data.message);
  }

  if(result?.data && result.data.status){
    setAssignedProjects(result.data.projects);
  }

  } catch (err) {
    console.error('Something went wrong during getting projects:',err);
  }
}

function verifyUser() {
const Surveyor_token = Cookies.get('Surveyor_token');
io.emit('verify', Surveyor_token);
}

useEffect(() => {
const current_token = Cookies.get('Surveyor_token');
if (!current_token) {
Navigete('/login');
return;
}
if (current_token) {
try {
const decoded = jwtDecode(current_token);
setmyid(decoded.id);
setmyName(decoded.name);
setProfileData(prev => ({
...prev,
name: decoded.name || "",
email: decoded.email || ""
}));
} catch (err) {
console.log('Invalid token', err);
}
}

if (io.connected) {
verifyUser();
} else {
io.on('connect', () => verifyUser());
}

io.on('getMessage', (message) => {
setMessages((prev) => [...prev, { from: 'admin', text: message }]);
});

io.on('message_sent',({message_sent,sender,senderId}) => {
  setChat((prev) => [
    ...prev,
    {
      msg: message_sent,
      from: sender,
      senderId
    }
  ]);
});

getProjects();

return () => {
io.off('message_sent');
io.off('getMessage');
io.off('connect', verifyUser);
};
}, []);

const team = async() => {
const Teamlist = await GetSurveyors();
const userProfile = Teamlist.find(u => u.member_id === myid);
if(userProfile) {
    setProfileData({
      name: userProfile.member_name,
      email: userProfile.member_email,
      phoneNumber: userProfile.member_phonenumber,
      imagePreview: userProfile.member_image,
      tempDisp: null 
    });
  }
setsurveyorsList(Teamlist);
}

useEffect(() => {
  team();
},[myid]);

const sendMessage = () => {
  io.on('ReceiverNotConnected',({message}) => {
  alert(message);
  })
  io.emit('team_member_message',{
    message_sent: input,
    receiverId: selectedSurveyor.member_id,
    sender: myName,
    senderId: myid
  });
if (input.trim() && selectedSurveyor) {
setChat((prev) => [...prev, { from: "You", msg: input,
  toWho: selectedSurveyor.member_id
}]);
setInput("");
}
};

const Handlelogout = () => {
Cookies.remove('Surveyor_token', { path: '/' });
Navigete('/logout');
};

const inputStyle = "w-full p-3 bg-white border border-gray-300 text-gray-900 text-sm rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all shadow-sm";

return (
<div className="relative flex h-screen overflow-hidden font-sans bg-gray-50">

  {/* Backdrop Overlay for Mobile Drawer Sidebar */}
  {isSidebarOpen && (
    <div 
      className="fixed inset-0 z-20 transition-opacity bg-gray-900/40 md:hidden backdrop-blur-sm"
      onClick={() => setIsSidebarOpen(false)}
    />
  )}

  {/* Sidebar - Left Section (Fully Responsive Drawer & Desktop Persistent View) */}
  <div className={`
    fixed inset-y-0 left-0 z-30 w-64 bg-slate-900 text-white shadow-2xl flex flex-col transform transition-transform duration-300 ease-in-out
    md:static md:translate-x-0 
    ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"}
  `}>
    <div className="flex items-center justify-between p-6 text-2xl font-black tracking-tight border-b border-slate-800">
      <div>
        Surveyor <span className="text-blue-400">Dash</span>
      </div>
      {/* Mobile Close Button */}
      <button className="text-gray-400 md:hidden hover:text-white" onClick={() => setIsSidebarOpen(false)}>
        <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
    
    <nav className="flex-1 px-4 py-6 space-y-1 overflow-y-auto">
      {["profile", "messages", "report", "chat", "progress", "logout"].map(tab => (
        <button
          key={tab}
          onClick={() => {
            setIsSidebarOpen(false); // close drawer window inside mobiles
            tab === 'logout' ? Handlelogout() : setActiveTab(tab);
          }}
          className={`w-full flex items-center p-3 text-sm font-semibold rounded-xl transition-all duration-200 ${
            activeTab === tab && tab !== 'logout'
              ? "bg-blue-600 text-white shadow-md shadow-blue-600/20" 
              : tab === 'logout' 
                ? "text-red-400 hover:bg-red-500/10" 
                : "text-gray-300 hover:bg-slate-800 hover:text-white"
          }`}
        >
          <span className="capitalize">{tab === 'messages' ? 'Admin Messages' : tab}</span>
        </button>
      ))}
    </nav>
  </div>

  {/* Main Content Side Panel (Right) */}
  <div className="flex flex-col flex-1 h-full overflow-hidden">

    {/* Top Navigation Header */}
    <header className="z-10 flex items-center justify-between h-16 px-4 bg-white border-b border-gray-200 shadow-sm sm:px-8">
      <div className="flex items-center gap-3">
        {/* Hamburger Menu Icon Trigger */}
        <button 
          onClick={() => setIsSidebarOpen(true)}
          className="p-2 -ml-2 text-gray-600 rounded-lg hover:bg-gray-100 md:hidden"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
        <h2 className="text-xl font-bold tracking-tight text-gray-800 capitalize">
          {activeTab === 'messages' ? 'Admin Messages' : activeTab.replace('_', ' ')}
        </h2>
      </div>

      <div className="flex items-center gap-3.5">
        <div className="hidden text-right sm:block">
          <p className="text-sm font-bold leading-none text-gray-800">{profileData.name || "Surveyor"}</p>
          <p className="mt-1 text-xs text-gray-400">{profileData.email}</p>
        </div>
        <img 
          src={profileData.tempDisp ? profileData.tempDisp : `https://land-survey-project-2.onrender.com/surveyors_images/${profileData.imagePreview}`} 
          className="object-cover w-10 h-10 transition border-2 border-white rounded-full shadow-sm cursor-pointer ring-2 ring-blue-500/20 hover:scale-105" 
          alt="User"
          onClick={() => setActiveTab('profile')}
        />
      </div>
    </header>

    {/* Scrollable Main Application Space */}
    <main className="flex-1 p-4 overflow-y-auto sm:p-8">
      <div className="h-full max-w-5xl mx-auto">

        {/* --- Messages Tab View --- */}
        {activeTab === "messages" && (
          <div className="max-w-3xl space-y-4">
            <div className="pb-2 mb-4 border-b">
              <p className="text-sm text-gray-500">Official incoming communications from central organization management</p>
            </div>
            {messages.length > 0 ? messages.map((msg, i) => (
              <div key={i} className="p-5 transition duration-200 bg-white border border-gray-200 shadow-sm rounded-2xl hover:shadow-md">
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-2 h-2 bg-blue-600 rounded-full animate-pulse"></span>
                  <span className="text-sm font-bold tracking-wide text-blue-600 uppercase">{msg.from}</span>
                </div>
                <p className="text-sm leading-relaxed text-gray-700 whitespace-pre-wrap">{msg.text}</p>
              </div>
            )) : (
              <div className="p-8 italic text-center text-gray-400 bg-white border shadow-sm rounded-2xl">
                No official messages from administration recorded yet.
              </div>
            )}
          </div>
        )}

        {/* --- Chat Tab View (Upgraded layout structure for Mobile + Desktop Screen Split) --- */}
        {activeTab === "chat" && (
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 flex flex-col md:flex-row h-[calc(100vh-12rem)] min-h-[450px] overflow-hidden">
            
            {/* Team List Column */}
            <div className={`
              w-full md:w-80 border-r border-gray-200 bg-gray-50/50 flex flex-col h-1/3 md:h-full
              ${selectedSurveyor ? 'hidden md:flex' : 'flex'}
            `}>
              <div className="flex items-center justify-between p-4 font-bold text-gray-800 bg-white border-b shadow-sm">
                <span>Active Team Members</span>
                <span className="bg-gray-100 text-gray-600 text-xs px-2.5 py-1 rounded-full font-semibold">
                  {surveyorsList ? surveyorsList.filter(m => m.member_id !== myid).length : 0}
                </span>
              </div>
              <div className="flex-1 p-2 space-y-1 overflow-y-auto">
               {surveyorsList && surveyorsList.length > 0 ? surveyorsList.filter(m => m.member_id !== myid).map((s) => (
                  <div 
                    key={s.member_id}
                    onClick={() => setSelectedSurveyor(s)}
                    className={`p-3.5 cursor-pointer rounded-xl transition-all flex items-center gap-3 ${
                      selectedSurveyor?.member_id === s.member_id 
                        ? "bg-blue-50 text-blue-900 border-l-4 border-blue-600 shadow-sm" 
                        : "hover:bg-gray-100/80 text-gray-700"
                    }`}
                  >
                    <div className="flex items-center justify-center text-sm font-bold text-white uppercase rounded-full shadow-sm w-9 h-9 bg-gradient-to-tr from-blue-600 to-indigo-600 shrink-0">
                      {s.member_name ? s.member_name.charAt(0) : '?'}
                    </div>
                    <div className="overflow-hidden">
                      <div className="text-sm font-bold truncate">{s.member_name}</div>
                      <div className="text-[11px] text-gray-400 truncate">{s.member_email || 'No email info'}</div>
                    </div>
                  </div>
                )) : (
                <div className="flex items-center justify-center h-full p-4 text-sm text-gray-400">No team members located</div>
               )}
              </div>
            </div>

            {/* Conversation Window View Panel */}
            <div className={`
              flex-1 flex flex-col h-2/3 md:h-full bg-white
              ${!selectedSurveyor ? 'hidden md:flex' : 'flex'}
            `}>
              {selectedSurveyor ? (
                <>
                  <div className="flex items-center justify-between p-4 font-bold text-gray-800 bg-white border-b shadow-sm">
                    <div className="flex items-center gap-3">
                      {/* Back to team button on mobile views */}
                      <button 
                        onClick={() => setSelectedSurveyor(null)} 
                        className="p-1 text-gray-500 rounded md:hidden hover:bg-gray-100"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                        </svg>
                      </button>
                      <div className="flex items-center justify-center w-8 h-8 text-xs font-bold text-gray-700 uppercase bg-gray-200 rounded-full">
                        {selectedSurveyor.member_name.charAt(0)}
                      </div>
                      <span className="text-sm font-bold truncate">Conversing with {selectedSurveyor.member_name}</span>
                    </div>
                  </div>
                  
                  <div className="flex-1 p-4 overflow-y-auto space-y-3.5 bg-gray-50/50">
                    {chat.filter(m => m.senderId === selectedSurveyor.member_id || (m.from === 'You' && m.toWho === selectedSurveyor.member_id)).map((chatMember, i) => (
                      <div key={i} className={`p-3.5 rounded-2xl max-w-[85%] sm:max-w-[75%] shadow-sm transition-all text-sm ${
                        chatMember.from === "You" 
                          ? "ml-auto bg-blue-600 text-white rounded-tr-none" 
                          : "bg-white border border-gray-200 text-gray-800 rounded-tl-none"
                      }`}>
                        <div className="text-[10px] font-bold tracking-wider uppercase mb-1 opacity-75">{chatMember.from}</div>
                        <div className="leading-relaxed break-words">{chatMember.msg}</div>
                      </div>
                    ))}
                  </div>
                  
                  <div className="flex items-center gap-2 p-3 bg-white border-t">
                    <input 
                      value={input} 
                      onChange={e => setInput(e.target.value)} 
                      onKeyDown={e => e.key === 'Enter' && sendMessage()}
                      className={inputStyle} 
                      placeholder={`Message ${selectedSurveyor.member_name}...`} 
                    />
                    <button 
                      onClick={sendMessage} 
                      className="px-5 py-3 font-bold text-white transition bg-blue-600 shadow-md rounded-xl hover:bg-blue-700 active:scale-95 shadow-blue-600/10"
                    >
                      Send
                    </button>
                  </div>
                </>
              ) : (
                <div className="flex flex-col items-center justify-center flex-1 p-8 text-center text-gray-400 bg-gray-50/30">
                  <div className="p-4 mb-4 text-blue-500 bg-gray-100 rounded-full">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                    </svg>
                  </div>
                  <p className="font-medium text-gray-500">Select a dynamic team worker from list to open a chat channel</p>
                </div>
              )}
            </div>
          </div>
        )}

        {/* --- Progress Tab View (Upgraded with Live Activity History Timeline) --- */}
{activeTab === "progress" && (
  <div className="max-w-3xl space-y-6">
    <div className="flex flex-col gap-2 pb-4 border-b sm:flex-row sm:items-center sm:justify-between">
      <div>
        <p className="text-sm text-gray-500">
          Log fresh field activity milestones. Every submission creates an independent, permanent history trail for clients and admins.
        </p>
      </div>
    </div>

    {/* Form to enter or create a new project baseline */}
    <div className="p-5 bg-white border border-blue-100 shadow-sm rounded-2xl bg-gradient-to-r from-blue-50/30 to-indigo-50/10">
      <h4 className="flex items-center gap-2 mb-3 text-sm font-bold text-gray-800">
        <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
        Create New Base Project Route
      </h4>
      <form onSubmit={handleCreateProject} className="flex flex-col gap-3 sm:flex-row">
        <input 
          type="text" 
          value={newProjectName}
          onChange={(e) => setNewProjectName(e.target.value)}
          placeholder="Enter custom project location or survey name..." 
          className={inputStyle}
        />
        <button 
          type="submit"
          className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-bold text-sm rounded-xl transition shadow-md shadow-blue-500/10 whitespace-nowrap active:scale-[0.98]"
        >
          Add Project
        </button>
      </form>
    </div>

    {/* Displaying the lists of projects inside trackers */}
    <div className="space-y-6">
      {assignedProjects.length === 0 && (
        <div className="p-8 italic text-center text-gray-400 bg-white border border-dashed shadow-sm rounded-2xl">
          No managed tracking modules recorded. Use the inputs above to start a new tracking index.
        </div>
      )}

      {assignedProjects.length > 0 && assignedProjects.map((p) => (
        <div key={p.id} className="p-6 transition-all bg-white border border-gray-200 shadow-md rounded-2xl hover:border-gray-300">
          
          {/* Project Header Meta */}
          <div className="flex items-start justify-between mb-3">
            <div>
              <span className="block text-lg font-bold text-gray-900">{p.projectname}</span>
              <span className="text-xs text-gray-400 font-medium mt-0.5 block">Unique Index ID: #{p.id}</span>
            </div>
            
            <div className="flex items-center gap-2">
              <span className="px-3 py-1 text-sm font-black text-blue-700 rounded-full bg-blue-50">
                Current Status: {p.requestprogress}%
              </span>
              <button
                onClick={() => handleDeleteProject(p.id, p.projectname)}
                className="p-1.5 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition"
                title="Delete project tracking"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-4v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>
            </div>
          </div>
          
          {/* Visual Progress Bar */}
          <div className="w-full h-3 bg-gray-100 rounded-full overflow-hidden p-0.5 border border-gray-200/50 mb-4">
            <div 
              className="h-full transition-all duration-300 ease-out rounded-full bg-gradient-to-r from-blue-500 to-indigo-600" 
              style={{ width: `${p.requestprogress}%` }}
            ></div>
          </div>

          {/* SECTION 1: Logging Form Control */}
          <div className="p-4 border border-gray-100 rounded-xl bg-gray-50/50">
            <h5 className="mb-3 text-xs font-bold tracking-wider text-gray-400 uppercase">Log a New Activity Entry</h5>
            
            <div className="flex items-center flex-1 gap-3 mb-4">
              <span className="text-xs font-bold text-gray-400">0%</span>
              <input 
                type="range" 
                min="0" 
                max="100" 
                value={p.requestprogress || 0}
                onChange={(e) => {
                  const val = Number(e.target.value);
                  setAssignedProjects(prev => prev.map(item => item.id === p.id ? { ...item, requestprogress: val } : item));
                }}
                className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-600"
              />
              <span className="text-xs font-bold text-gray-400">100%</span>
            </div>

            <div className="flex flex-col gap-3">
              <input 
                type="text" 
                value={p.progressTitle || ""}
                onChange={(e) => {
                  const val = e.target.value;
                  setAssignedProjects(prev => prev.map(item => item.id === p.id ? { ...item, progressTitle: val } : item));
                }} 
                placeholder="What action did you perform right now? (e.g., Boundary stakes driven)" 
                className="w-full px-3 py-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm outline-none focus:border-blue-500 placeholder:text-gray-400"
              />
              <textarea 
                value={p.progressSummary || ""}
                rows={2}
                onChange={(e) => {
                  const val = e.target.value;
                  setAssignedProjects(prev => prev.map(item => item.id === p.id ? { ...item, progressSummary: val } : item));
                }} 
                placeholder="Provide deep details or findings explaining this action to client..."
                className="w-full px-3 py-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm outline-none resize-none focus:border-blue-500 placeholder:text-gray-400"
              />
            </div>

            <button
              onClick={() => handleUpdateProgress(p.id, p.requestprogress)}
              className="mt-3 px-4 py-2 bg-slate-800 hover:bg-slate-900 text-white font-bold text-xs rounded-lg shadow-sm transition active:scale-[0.98]"
            >
              Submit New Activity Snapshot
            </button>
          </div>

          {/* SECTION 2: Chronological Activity Trail Feed */}
          <div className="mt-5">
            <h5 className="text-xs font-bold tracking-wider text-gray-400 uppercase mb-3 flex items-center gap-1.5">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Activity Audit Trail (Seen by Admin & Clients)
            </h5>
            
            {/* Checks if an activity snapshot exists on the item object */}
            {p.progressTitle ? (
              <div className="pr-1 space-y-3 overflow-y-auto max-h-48">
                <div className="p-3 text-sm transition border-l-4 border-blue-500 bg-slate-50 rounded-r-xl">
                  <div className="flex items-center justify-between mb-1">
                    <span className="font-bold text-gray-800">{p.progressTitle}</span>
                    <span className="text-[10px] font-mono bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full font-bold">
                      {p.requestprogress}% Status
                    </span>
                  </div>
                  <p className="text-xs leading-relaxed text-gray-600">{p.progressSummary}</p>
                  <span className="text-[10px] text-gray-400 mt-1 block">Latest recorded field change</span>
                </div>
              </div>
            ) : (
              <div className="p-4 text-xs italic text-center text-gray-400 border border-dashed bg-gray-50 rounded-xl">
                No verified historical timeline events logged for this module yet.
              </div>
            )}
          </div>

        </div>
      ))}
    </div>
  </div>
)}

        {/* --- Report Form Tab View --- */}
        {activeTab === "report" && (
          <div className="max-w-2xl">
            <div className="pb-2 mb-6 border-b">
              <p className="text-sm text-gray-500">File standard daily field updates directly into operational records</p>
            </div>
            <div className="p-6 bg-white border border-gray-200 shadow-sm rounded-2xl">
              <label className="block mb-2 text-xs font-bold tracking-wider text-gray-500 uppercase">Detailed Report Summary</label>
              <textarea 
                value={report} 
                onChange={e => setReport(e.target.value)} 
                className={`${inputStyle} h-44 mb-4 resize-none`} 
                placeholder="Type comprehensive details describing survey data parameters collected, field observations, roadblocks, etc..." 
              />
              <button 
                onClick={submitReport} 
                className="w-full py-3.5 bg-blue-600 text-white rounded-xl font-bold hover:bg-blue-700 transition shadow-lg shadow-blue-600/20 active:scale-[0.99]"
              >
                Submit Report to Admin Office
              </button>
            </div>
          </div>
        )}

        {/* --- Profile Update Tab View --- */}
        {activeTab === "profile" && (
          <div className="max-w-xl mx-auto mt-2 overflow-hidden bg-white border border-gray-200 shadow-sm rounded-2xl">
            <div className="h-28 bg-gradient-to-r from-blue-600 to-indigo-700"></div>
            <div className="px-6 pb-8 sm:px-8">
              <div className="relative flex flex-col items-center mb-2 -top-14">
                <div className="relative group">
                  <img 
                    src={profileData.tempDisp ? profileData.tempDisp : `https://land-survey-project-2.onrender.com/surveyors_images/${profileData.imagePreview}`} 
                    className="object-cover bg-gray-100 border-4 border-white rounded-full shadow-xl w-28 h-28 ring-4 ring-gray-100/50" 
                    alt="Avatar" 
                  />
                  <label className="absolute p-2 text-white transition transform bg-blue-600 border-2 border-white rounded-full shadow-md cursor-pointer bottom-1 right-1 hover:bg-blue-700 hover:scale-110">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                    </svg>
                    <input type="file" className="hidden" onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        setProfileData({...profileData, imagePreview: file, tempDisp: URL.createObjectURL(file)});
                      }
                    }} />
                  </label>
                </div>
                <h3 className="mt-3 text-2xl font-black text-gray-800">{profileData.name || "Surveyor User"}</h3>
                <p className="text-xs font-semibold text-gray-400 mt-0.5 tracking-wide uppercase">Verified Professional Field Member</p>
              </div>
              
              <form onSubmit={handleUpdateProfile} className="-mt-4 space-y-4">
                <div>
                  <label className="block text-[11px] font-bold text-gray-400 uppercase tracking-wider mb-1 px-1">Full Name</label>
                  <input type="text" className={inputStyle} value={profileData.name} placeholder="Name" onChange={(e) => setProfileData({...profileData, name: e.target.value})} />
                </div>
                <div>
                  <label className="block text-[11px] font-bold text-gray-400 uppercase tracking-wider mb-1 px-1">Email ID</label>
                  <input type="email" className={inputStyle} value={profileData.email} placeholder="Email" onChange={(e) => setProfileData({...profileData, email: e.target.value})} />
                </div>
                <div>
                  <label className="block text-[11px] font-bold text-gray-400 uppercase tracking-wider mb-1 px-1">Contact Phone</label>
                  <input type="text" className={inputStyle} value={profileData.phoneNumber || ""} placeholder="Phone Number" onChange={(e) => setProfileData({...profileData, phoneNumber: e.target.value})} />
                </div>
                <div>
                  <label className="block text-[11px] font-bold text-gray-400 uppercase tracking-wider mb-1 px-1">Access Authorization Password</label>
                  <input type="password" className={inputStyle} placeholder="New Password (leave empty to keep unchanged)" onChange={(e) => setProfileData({...profileData, password: e.target.value})} />
                </div>
                <button type="submit" className="w-full mt-6 py-3.5 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl font-bold hover:from-blue-700 hover:to-blue-800 transition shadow-lg shadow-blue-600/20 active:scale-[0.99]">
                  Update Personal Profile Records
                </button>
              </form>
            </div>
          </div>
        )}
      </div>
    </main>
  </div>
</div>
);
}
